import React, { useState, useEffect, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Autocomplete,
  TextField,
  Typography,
  Box,
  Grid,
  FormControl,
  Select,
  Checkbox,
  MenuItem,
  Button,
  FormGroup,
  InputLabel,
  Tooltip,
  Switch,
  IconButton
} from "@mui/material";
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { RateCard } from "routes/components";
import { gstNumberRegex, pdfDocReg, pdfImgReg, emailReg, StringRegex } from "utils/Regex";
import {
  handleValidationForm,
  handleWindowScroll,
  reservationHeader,
  truncateComment,
  validatePhoneNumber
} from "utils/utils";
import { billingTypeEnum, imageSize, tripDutyTypeEnum } from "utils/enumObj";
import DateTab from "components/commonDateRangePicker/CommonDateRangePicker";
import CommonButton from "components/commonButton/CommonButton";
import {
  RentalFields,
  airportTransfer,
  branchOption,
  outstationFields,
  userOption,
  billingDetails,
  toAirportForm,
  fromAirportForm,
  bookingFormBorder,
} from "pages/reservation/ReservationData";
import FareBreakUp from "pages/reservation/FareBreakUp";
import CustomTextfield from "./customTextfield/CustomTextfield";
import CustomBranchFields from "./customBranchFields/CustomBranchFields";
import CommonDateTimePicker from "./commonDateTimePicker/CommonDateTimePicker";
import CustomDomainFields from "./customDomainField/CustomDomainField";
import CustomMemberFields from "./customMemberFields/CustomMemberFields";
import CommonMultiFile from "./CommonMultiFile";
import CommonLabelInfo from "./CommonLabelInfo";
import UploadIcon from "assets/images/UploadIcon.svg";
import "./CommonMultiForm.scss";
import CabFacilities from 'pages/reservation/CabFacilities';
import Loader from "components/loader/Loader";
import CommonGoogleAutoComplete from "components/commonGoogleAutoComplete/CommonGoogleAutoComplete";
import userEvent from "@testing-library/user-event";
import { BlueSwitchBtn } from "pages/configuration/addCompliance/AddComplianceStyleTab";
import { clearPlaceDetails } from "redux/actions/UserGoogleMap";
import RateCardV1 from "pages/company/rateCardNew/rateCardNew";
import PreviewIcon from '@mui/icons-material/Visibility';
import PlacardModal from 'components/placardModal/PlacardModal';
import GarageRateConfiguration from "./slabBasedRateCard/slabBasedRateCard";
import { getAutoComplete } from "redux/actions/UserGoogleMap";
import {debounce} from 'lodash'

export default function CommonMultiForm(props) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
    setError,
    getValues,
    clearErrors,
    reset,
  } = useForm({ defaultValues: props?.defaultValues, mode: "onChange" });

  const [formError, setFormError] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [disableGarage, setdisableGarage] = useState({ disable: true, required: false });
  const [selectValues, setSelectValues] = useState({});
  const [domain, setDomain] = useState(props?.companyEmail ? props?.companyEmail?.allowedDomain : "");
  const [previewModal, setPreviewModal] = useState(false);
  const [selectedTripId, setSelectedTripId] = useState("");
  const [mandatoryField, setMandatoryField] = useState({
    field: "",
    status: false,
  });

  const [autoCompleteFieldValue, setAutoCompletFieldValue] = useState({
    companyId: "",
    employeeEmail: "",
    dutyTypeId: "",
    vehicleCategoryId: "",
    location: "",
  });

  const [formData, setFormData] = useState({});
  const uploadFileRef = useRef(null);
  const [datePickerKey, setDatePickerKey] = useState(0);
  const [openDateTimePicker, setOpenDateTimePicker] = useState(false);
  // ---Country Code---
  const [country, setCountry] = useState("+91");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [image, setImage] = useState({ name: "", file: "" });

  // Open the uploaded file in a new browser tab.
  const openFilePreview = () => {
    const previewUrl =
      image instanceof File ? URL.createObjectURL(image) : image?.file;
    if (previewUrl) {
      window.open(previewUrl, "_blank", "noopener,noreferrer");
    }
  };
  const [dynamicInputs, setDynamicInputs] = useState([]);
  const [dynamicDomain, setDynamicDomain] = useState([]);
  const [dynamicAdmins, setDynamicAdmins] = useState([{ name: "", email: "", phone: "", countryCode: "+91" }]);
  const [dynamicFinances, setDynamicFinances] = useState([{ name: "", email: "", phone: "", countryCode: "+91" }]);
  const [selectedMultiFiles, setSelectedMultiFiles] = useState([]);
  const [multiFileError, setMultiFileError] = useState("");
  const [multiFileTypeError, setMultiFileTypeError] = useState("");
  const [fileTypeError, setFileTypeError] = useState("");
  const [imgError, setImgError] = useState("");
  const formValues = getValues();
  const [tentureDate, setTentureDate] = useState("");
  const [deleteFileId, setDeleteFileId] = useState([]);
  const [commonSwitch, setCommonSwitch] = useState({ admin: false, finance: false });
  const [guestDetails, setGuestDetails] = useState([]);
  const [garageRateType, setGarageRateType] = useState(null);
  const [garageSlabs, setGarageSlabs] = useState([
    { minKm: 0, maxKm: 5, rate: '' }
  ]);

  const radioName = props?.radioSelected;
  let tempFormData = formData;

  const [formValidationObj, setFormValidationObj] = useState({});
  const [pickupLandmarkRequired, setPickupLandmarkRequired] = useState({
    pickUp: props.editType ? false : true,
    landmark: props.editType ? false : true,
  });

  const locationData = useSelector(state => state.userAutoComplete?.userAutoComplete?.data);
  const locationDataLoader = useSelector(state => state.userAutoComplete?.userAutoComplete);

  //Handling useEffect for adding default values
  useEffect(() => {
    if (props.defaultValues) {
      setAutoCompletFieldValue(props?.defaultValues);
    }
  }, []);

  useEffect(() => {
    const travelerCount = parseInt((formValues?.noOfTravelers - 1) || 0);

    if (travelerCount > 0) {
      // Initialize guest details array
      const newGuestDetails = Array.from({ length: travelerCount }, (_, index) => ({
        id: index,
        name: '',
        phone: '',
        countryCode: '+91'
      }));
      setGuestDetails(newGuestDetails);

      // Set form values for each guest if they don't exist
      newGuestDetails.forEach((_, index) => {
        if (!formValues[`guestName_${index}`]) {
          setValue(`guestName_${index}`, '');
        }
        if (!formValues[`guestPhone_${index}`]) {
          setValue(`guestPhone_${index}`, '');
        }
        if (!formValues[`guestCountryCode_${index}`]) {
          setValue(`guestCountryCode_${index}`, '+91');
        }
      });
    } else {
      setGuestDetails([]);
    }
  }, [formValues?.noOfTravelers, setValue]); // Watch for changes in noOfTravelers

  useEffect(() => {
    setCountry(props?.defaultValues?.countryCode || "+91")
  }, [props?.defaultValues?.countryCode])

  useEffect(() => {
    if (props?.type === "dashboardCompany") {
      const [month, day, year] = props?.tentureDate
        ? props?.tentureDate?.split("/")
        : "";
      setTentureDate(new Date(`${year}-${day}-${month}`));
    }
  }, [props?.tentureDate]);
  const { existingUser, newUser, guestUser, guestDepartmentCode, employeeCode } = userOption();
  const { existingBranch, newBranch } = branchOption();

  useEffect(() => {
    if (props?.defaultValues) {
      setSelectValues(
        props?.defaultValues ||
        props?.defaultValues?.Contracts?.[0]?.CompanyContracts
      );

      if (props?.defaultValues?.config === 'Point-To-Garage') {
        setdisableGarage({ ...disableGarage, disable: false, required: true })
      }

      let contractDetails = "";
      if (props?.defaultValues?.Contracts) {
        contractDetails =
          props?.defaultValues?.Contracts?.[0]?.ContractDetails?.filter(
            (obj) => obj?.type === "city"
          );
      }
      let companyAddress = "";
      if (props?.defaultValues?.branch) {
        let tempcompanyies = props?.defaultValues?.branch || [{}];
        const index = tempcompanyies.findIndex(
          (obj) => obj.isHeadquarter === true
        );
        if (index >= 0) {
          //if the matching element is found,
          const updatedData = [...tempcompanyies];
          //then remove that element and use `unshift`
          updatedData.unshift(...updatedData.splice(index, 1));
          companyAddress = updatedData;
        }
      }
      for (let i = 0; i < companyAddress?.length; i++) {
        setDynamicInputs((oldArray) => [
          ...oldArray,
          {
            [`city-${i}`]: companyAddress[`${i}`]?.cityId,
            [`address-${i}`]: companyAddress[`${i}`]?.address,
            [`state-${i}`]: companyAddress[`${i}`]?.state,
            [`gstNumber-${i}`]: companyAddress[`${i}`]?.gstNumber,
            [`sez-${i}`]: companyAddress[`${i}`]?.sez,
            [`garageLocation-${i}`]: companyAddress[`${i}`]?.additionalInfo?.garageLocation,
            [`garageAddress-${i}`]: companyAddress[`${i}`]?.additionalInfo?.garageAddress,
          },
        ]);

        setValue(`city-${i}`, companyAddress[`${i}`]?.cityId);
        setValue(`address-${i}`, companyAddress[`${i}`]?.address);
        setValue(`state-${i}`, companyAddress[`${i}`]?.state);
        setValue(`gstNumber-${i}`, companyAddress[`${i}`]?.gstNumber);
        setValue(`sez-${i}`, companyAddress[`${i}`]?.sez);
        setValue(`garageLocation-${i}`, companyAddress[`${i}`]?.additionalInfo?.garageLocation)
        setValue(`garageAddress-${i}`, companyAddress[`${i}`]?.additionalInfo?.garageAddress)
      }
      let allowedDomains = "";
      allowedDomains = props?.defaultValues?.allowedDomain || [''];
      for (let i = 0; i < allowedDomains?.length; i++) {
        setDynamicDomain((oldArray) => [
          ...oldArray,
          {
            [`allowedDomain-${i}`]: allowedDomains[`${i}` || ''],
          },
        ]);
        setValue(`allowedDomain-${i}`, allowedDomains[`${i}`] || '');
      }

      if (props?.formType === "companyOnbaording") {
        const documentsType =
          props?.defaultValues?.Contracts?.[0]?.AdditionalDocuments;

        const contractText =
          props?.defaultValues?.Contracts?.[0]?.Agreements?.[0]?.agreement;

        setImage({
          ...image,
          name: contractText?.name,
          file: contractText?.url,
        });

        setSelectedMultiFiles(documentsType);
      }

      if (props?.formType === "reservation") {
        if (props?.defaultValues?.doc?.name) {
          setImage({
            ...image,
            name: props?.defaultValues?.doc?.name,
            file: props?.defaultValues?.doc?.url,
          });
        }
      }
      if (props?.formType === "payment") {
        setImage({
          name: props?.defaultValues?.settlementImg?.name,
          file: props?.defaultValues?.settlementImg?.url,
        });
      }
    } else {
      setDynamicDomain([{
        "allowedDomain-0": ""
      }])
      setDynamicInputs([
        {
          "city-0": "",
          "address-0": "",
          "state-0": "",
          "gstNumber-0": "",
          "sez-0": "",
          "garageLocation-0": "",
          "garageAddress-0": ""
        },
      ]);
    }

    if (props?.defaultValues?.garageRateType) {
      setGarageRateType(props.defaultValues.garageRateType);
      
      if (props.defaultValues.garageRateType === 'per_km' && props.defaultValues.garageRateConfig?.rate_per_km) {
        setSelectValues((prevState) => ({
          ...prevState,
          garagePerKmRate: props.defaultValues.garageRateConfig.rate_per_km
        }));
      } else if (props.defaultValues.garageRateType === 'slab' && props.defaultValues.garageRateConfig?.slabs) {
        setGarageSlabs(props.defaultValues.garageRateConfig.slabs);
      }
    }

    // Initialise admin/finance member rows from defaultValues (edit mode)
    if (props?.formName === 'companyAdminFinance' && props?.defaultValues) {
      const dv = props.defaultValues;
      // Collect all indexed admin entries
      const adminRows = [];
      let i = 0;
      while (dv[`adminName_${i}`] !== undefined || dv[`adminEmail_${i}`] !== undefined) {
        adminRows.push({
          ...(dv[`adminId_${i}`] ? { id: dv[`adminId_${i}`] } : {}),
          name: dv[`adminName_${i}`] || "",
          email: dv[`adminEmail_${i}`] || "",
          phone: dv[`adminPhone_${i}`] || "",
          countryCode: "+91",
        });
        i++;
      }
      if (adminRows.length > 0) setDynamicAdmins(adminRows);

      const financeRows = [];
      let j = 0;
      while (dv[`financeName_${j}`] !== undefined || dv[`financeEmail_${j}`] !== undefined) {
        financeRows.push({
          ...(dv[`financeId_${j}`] ? { id: dv[`financeId_${j}`] } : {}),
          name: dv[`financeName_${j}`] || "",
          email: dv[`financeEmail_${j}`] || "",
          phone: dv[`financePhone_${j}`] || "",
          countryCode: "+91",
        });
        j++;
      }
      if (financeRows.length > 0) setDynamicFinances(financeRows);
    }
  }, []);

  useEffect(() => {
    if (
      props?.formType === "reservation" &&
      props?.defaultValues?.billingType
    ) {
      setValue("billingType", props?.defaultValues?.billingType);
      setSelectValues((prevState) => ({
        ...prevState,
        billingType: props?.defaultValues?.billingType,
      }));
    }
  }, [props.defaultValues]);

const handlePlacardPreview = () => {
  const placardText = getValues('placardText'); // Get placard text from form
  if (placardText) {
    setSelectedTripId(placardText); // We'll reuse this state to store placard text
    setPreviewModal(true);
  }
};

const handlePreviewClose = () => {
  setPreviewModal(false);
};

const shouldRenderField = (field) => {
  // Check for placard fields
  if (field.name === 'needPlacard' || field.name === 'placardText') {
    const dutyVal = getValues("dutyTypeId");
    const dutyTypeId = dutyVal?.id;
    // Only show for Airport Transfer and Rental
    const isValidDutyType = dutyTypeId === tripDutyTypeEnum.airpotTransfer || 
           dutyTypeId === tripDutyTypeEnum.rental;
    if (field.name === 'placardText') {
      return isValidDutyType && getValues('needPlacard') === true;
    }
    return isValidDutyType;
  }
  // Duty Type check for other fields
  if (field?.showForDutyTypes) {
    const dutyVal = getValues("dutyTypeId");
    // Handle both object format (create mode) and string format (edit mode)
    let selectedDutyLabel = "";
    if (dutyVal) {
      if (typeof dutyVal === 'string') {
        // Edit mode: dutyVal is a string like "Rental"
        selectedDutyLabel = dutyVal;
      } else {
        // Create mode: dutyVal is an object with label property
        selectedDutyLabel = dutyVal.label || dutyVal.name || dutyVal;
      }
    }
    if (!field.showForDutyTypes.includes(selectedDutyLabel)) {
      return false;
    }
  }

  // Check dependent fields
  if (field?.dependentField) {
    if (Array.isArray(field.dependentField)) {
      for (const dep of field.dependentField) {
        if (!getValues(dep)) return false;
      }
    } else {
      if (!getValues(field.dependentField)) return false;
    }
  }

  return true;
};

  //company onboard common function for setValue
  // Cache parent data in a ref so toggle-off → toggle-on always has the original data
  const cachedParentData = React.useRef(null);

  const handleSwitchValue = (name, status) => {
    // On first toggle-on, cache the parent data; reuse on subsequent toggles
    if (status && props?.parentCompanyAdminDetails) {
      cachedParentData.current = props.parentCompanyAdminDetails;
    }
    const raw = cachedParentData.current || props?.parentCompanyAdminDetails;
    // API returns same shape as company profile — Employees[] with userRole
    const employees = raw?.Employees || raw?.employees || [];

    if (name === "admin") {
      const adminDetails = employees.filter(e => e.userRole === 'Admin' || e.userRole === 'admin').length > 0
        ? employees.filter(e => e.userRole === 'Admin' || e.userRole === 'admin')
        : raw?.admins?.length > 0
          ? raw.admins
          : raw?.admin
            ? (Array.isArray(raw.admin) ? raw.admin : [raw.admin])
            : [];
      if (status && adminDetails.length > 0) {
        const rows = adminDetails.map(a => ({ name: a?.name || "", email: a?.email || "", phone: a?.phoneNumber || a?.mobileNumber || "", countryCode: a?.countryCode || "+91" }));
        setDynamicAdmins(rows);
      } else if (status && adminDetails.length === 0) {
        // Parent has no admins — clear fields to blank (will be disabled)
        setDynamicAdmins([{ name: "", email: "", phone: "", countryCode: "+91" }]);
      } else if (!status) {
        setDynamicAdmins([{ name: "", email: "", phone: "", countryCode: "+91" }]);
      }
    } else if (name === "finance") {
      const financeDetails = employees.filter(e => e.userRole === 'Finance' || e.userRole === 'finance').length > 0
        ? employees.filter(e => e.userRole === 'Finance' || e.userRole === 'finance')
        : raw?.finances?.length > 0
          ? raw.finances
          : raw?.finance
            ? (Array.isArray(raw.finance) ? raw.finance : [raw.finance])
            : [];
      if (status && financeDetails.length > 0) {
        const rows = financeDetails.map(f => ({ name: f?.name || "", email: f?.email || "", phone: f?.phoneNumber || f?.mobileNumber || "", countryCode: f?.countryCode || "+91" }));
        setDynamicFinances(rows);
      } else if (status && financeDetails.length === 0) {
        // Parent has no finance — clear fields to blank (will be disabled)
        setDynamicFinances([{ name: "", email: "", phone: "", countryCode: "+91" }]);
      } else if (!status) {
        setDynamicFinances([{ name: "", email: "", phone: "", countryCode: "+91" }]);
      }
    }
  }

  useEffect(() => {
    if (props?.companyEdit) {
      setCommonSwitch({ ...commonSwitch, admin: props?.hasParentAdmin, finance: props?.hasParentFinance });
      // Cache parent data immediately so toggle always has it
      if (props?.parentCompanyAdminDetails) {
        cachedParentData.current = props.parentCompanyAdminDetails;
      }
      if (props?.switchDisable && props?.companyEdit) {
        if (props?.hasParentAdmin) {
          handleSwitchValue("admin", true);
        }
        if (props?.hasParentFinance) {
          handleSwitchValue("finance", true);
        }
      }
    }
  }, [props?.defaultValues?.adminName])

  useEffect(() => {
    if (props.editType) {
      let tempFormData = props?.formData;
      if (tempFormData["dutyAndVehicle"]?.length) {
        if (props.defaultValues?.tripType === tripDutyTypeEnum.airpotTransfer) {
          if (props.defaultValues?.airportRideType === "To-Airport") {
            tempFormData["tripDetails"] = [
              ...toAirportForm(
                props.airportTerminalOption,
                props?.editType
              ),
            ];
          } else {
            tempFormData["tripDetails"] = [
              ...fromAirportForm(
                props.airportTerminalOption,
                props?.editType
              ),
            ];
          }
        } else if (props.defaultValues?.tripType === tripDutyTypeEnum.rental) {
          tempFormData["tripDetails"] = [
            ...RentalFields(props?.rateCardPackage, props?.editType, false),
          ];
        } else {
          tempFormData["tripDetails"] = [...outstationFields(props?.editType)];
        }
      }
      setFormData(tempFormData);
    } else {
      if (props?.formData) {
        setFormData(props?.formData);
      }
    }
  }, []);

  useEffect(() => {
    if (props?.payment) {
      setFormData(props?.formData);
    }
  }, [props?.formData]);

  useEffect(() => {
    let tempFormData = formData;
    if (props?.companyList?.length > 0 && tempFormData["bookingCompany"]) {
      tempFormData["bookingCompany"][0].optionData = props?.companyList;

      setFormData({
        ...formData,
        bookingCompany: [...tempFormData["bookingCompany"]],
      });
    }
  }, [props?.companyList]);

  useEffect(() => {
    setFormData((prevFormData) => {
      if (
        !prevFormData["travellerDetails"]?.length ||
        !prevFormData["dutyAndVehicle"]?.length
      ) {
        return prevFormData;
      }

      let hasChanges = false;
      const updatedFormData = { ...prevFormData };

      // Update traveller details - employee list
      if (props?.companyEmployeeList) {
        const employeeList =
          props?.companyEmployeeList?.[0] === "No Data Found"
            ? []
            : props?.companyEmployeeList;
        const updatedTravellerDetails = prevFormData["travellerDetails"].map(
          (field, idx) => {
            if (idx === 1 && field?.name === "employeeEmail") {
              // Only update if different
              if (
                JSON.stringify(field?.optionData) !==
                JSON.stringify(employeeList)
              ) {
                hasChanges = true;
                return { ...field, optionData: employeeList };
              }
            }
            return field;
          }
        );
        updatedFormData["travellerDetails"] = updatedTravellerDetails;
      }

      // Update duty and vehicle fields using dynamic field finding
      const updatedDutyAndVehicle = prevFormData["dutyAndVehicle"].map(
        (field) => {
          // Update city options dynamically by name
          if (field?.name === "location" && props?.cityOption) {
            if (
              JSON.stringify(field?.optionData) !==
              JSON.stringify(props?.cityOption)
            ) {
              hasChanges = true;
              return { ...field, optionData: props?.cityOption };
            }
          }
          // Update duty type options dynamically by name
          if (field?.name === "dutyTypeId" && props?.dutyTypeOption) {
            if (
              JSON.stringify(field?.optionData) !==
              JSON.stringify(props?.dutyTypeOption)
            ) {
              hasChanges = true;
              return { ...field, optionData: props?.dutyTypeOption };
            }
          }
          return field;
        }
      );

      if (hasChanges) {
        updatedFormData["dutyAndVehicle"] = updatedDutyAndVehicle;
      }

      // Update billing type
      if (props?.billingType) {
        const newBillingDetails = billingDetails(
          props?.billingType,
          props?.editType || isDisabled
        );
        if (
          JSON.stringify(updatedFormData["billingType"]?.[0]) !==
          JSON.stringify(newBillingDetails)
        ) {
          hasChanges = true;
          updatedFormData["billingType"] = [newBillingDetails];
        }
      }

      return hasChanges ? updatedFormData : prevFormData;
    });
  }, [props?.companyEmployeeList, props?.dutyTypeOption, props?.cityOption, props?.billingType, props?.editType, isDisabled]);

  useEffect(() => {
    if (props?.SelectedCarListOption) {
      setFormData((prevFormData) => {
        if (!prevFormData["dutyAndVehicle"]) {
          return prevFormData;
        }
        
        // Find the vehicleCategoryId field dynamically by name instead of hardcoding index
        const vehicleCategoryIndex = prevFormData["dutyAndVehicle"].findIndex(
          (field) => field?.name === "vehicleCategoryId"
        );
        
        if (vehicleCategoryIndex === -1) {
          return prevFormData;
        }
        
        // Create a deep copy to avoid mutations
        const updatedDutyAndVehicle = prevFormData["dutyAndVehicle"].map((field, idx) => {
          if (idx === vehicleCategoryIndex) {
            return {
              ...field,
              optionData: props?.SelectedCarListOption,
            };
          }
          return field;
        });
        
        return {
          ...prevFormData,
          dutyAndVehicle: updatedDutyAndVehicle,
        };
      });
    }
  }, [props?.SelectedCarListOption]);

  useEffect(() => {
    if (props?.rateCardPackage) {
      setFormData((prevFormData) => {
        if (!prevFormData["tripDetails"]) {
          return prevFormData;
        }

        // Find the package field dynamically by name
        const packageIndex = prevFormData["tripDetails"].findIndex(
          (field) => field?.name === "package"
        );

        if (packageIndex === -1) {
          return prevFormData;
        }

        // Create a deep copy with only the package field updated
        const updatedTripDetails = prevFormData["tripDetails"].map(
          (field, idx) => {
            if (idx === packageIndex) {
              return {
                ...field,
                menuOptions: props?.rateCardPackage,
              };
            }
            return field;
          }
        );

        return {
          ...prevFormData,
          tripDetails: updatedTripDetails,
        };
      });
    }
  }, [props?.rateCardPackage]);

  useEffect(() => {
    if (props?.airportTerminalOption && !props.editType) {
      setFormData((prevFormData) => {
        if (!prevFormData["tripDetails"] || prevFormData["tripDetails"].length < 2) {
          return prevFormData;
        }

        // Find toAirportTerminal field dynamically by name
        const toAirportTerminalIndex = prevFormData["tripDetails"].findIndex(
          (field) => field?.name === "toAirportTerminal"
        );

        if (toAirportTerminalIndex === -1) {
          return prevFormData;
        }

        // Create a deep copy with only the terminal field updated
        const updatedTripDetails = prevFormData["tripDetails"].map(
          (field, idx) => {
            if (idx === toAirportTerminalIndex) {
              return {
                ...field,
                menuOptions: props?.airportTerminalOption,
              };
            }
            return field;
          }
        );

        return {
          ...prevFormData,
          tripDetails: updatedTripDetails,
        };
      });
    }
  }, [props?.airportTerminalOption, props?.editType]);

  // Update selectValues when airport terminal options change in edit mode
  useEffect(() => {
    if (props?.editType && props?.airportTerminalOption && Array.isArray(props?.airportTerminalOption) && props?.defaultValues) {
      const toTerminalValue = props?.defaultValues?.toAirportTerminal;
      const fromTerminalValue = props?.defaultValues?.fromAirportTerminal;
      
      // Find matching terminal options by label (address) and get their IDs for pre-selection
      let toTerminalId = toTerminalValue;
      let fromTerminalId = fromTerminalValue;
      
      if (toTerminalValue && typeof toTerminalValue === 'string') {
        // Try to find the matching terminal by comparing the label with the stored address
        const matchedTo = props?.airportTerminalOption?.find(
          (option) => option?.label === toTerminalValue
        );
        if (matchedTo) {
          toTerminalId = matchedTo?.value;
        }
      }
      
      if (fromTerminalValue && typeof fromTerminalValue === 'string') {
        // Try to find the matching terminal by comparing the label with the stored address
        const matchedFrom = props?.airportTerminalOption?.find(
          (option) => option?.label === fromTerminalValue
        );
        if (matchedFrom) {
          fromTerminalId = matchedFrom?.value;
        }
      }
      
      // Update selectValues with the terminal IDs (needed for dropdown pre-selection matching MenuItem values)
      setSelectValues((prevState) => ({
        ...prevState,
        toAirportTerminal: toTerminalId,
        fromAirportTerminal: fromTerminalId,
      }));
      
      // Set form values with IDs — NewReservation.js already resolves ID to label via airportTerminalOption lookup
      setValue("toAirportTerminal", toTerminalId);
      setValue("fromAirportTerminal", fromTerminalId);
    }
  }, [props?.airportTerminalOption, props?.editType, props?.defaultValues?.toAirportTerminal, props?.defaultValues?.fromAirportTerminal]);

  const onInputChangeVal = (event, value) => {
    props?.onInputChangeVal(value, event);
  };

  const onHandleChange = (event, value, name) => {
    props?.onHandleChange(event, value, name);
    const clearErrorFiled = [
      "landmark",
    ];
    if (name === "pickUp") {
      if (event.type === "change" && !value) {
        setPickupLandmarkRequired({ landmark: true, pickUp: true });
      }
      else {
        setPickupLandmarkRequired({ landmark: false, pickUp: true });
      }
    }
    clearErrors(clearErrorFiled);

  };

  const validateGuestDetails = () => {
    let isValid = true;
    const guestErrors = {};
  
    guestDetails.forEach((guest, index) => {
      const guestName = formValues[`guestName_${index}`];
      const guestPhone = formValues[`guestPhone_${index}`];
  
      // Validate name field (mandatory)
      if (!guestName || guestName.trim() === '') {
        setError(`guestName_${index}`, {
          type: 'manual',
          message: 'Guest name is required'
        });
        isValid = false;
      }
  
      // Validate phone number field (mandatory)
      if (!guestPhone || guestPhone.trim() === '') {
        setError(`guestPhone_${index}`, {
          type: 'manual',
          message: 'Guest phone number is required'
        });
        isValid = false;
      } else {
        // Validate phone number length (10 digits)
        const phoneDigits = guestPhone.replace(/\D/g, '');
        if (phoneDigits.length !== 10) {
          setError(`guestPhone_${index}`, {
            type: 'manual',
            message: 'Phone number must be exactly 10 digits'
          });
          isValid = false;
        }
      }
    });
  
    return isValid;
  };


  const handleGuestNameChange = (e, index) => {
    const updatedGuests = [...guestDetails];
    updatedGuests[index].name = e.target.value;
    setGuestDetails(updatedGuests);
    
    // Clear error when user starts typing
    if (errors[`guestName_${index}`]) {
      clearErrors(`guestName_${index}`);
    }
  };
  

  const handleGuestPhoneChange = (e, index) => {
    const phoneValue = e.target.value.replace(/\D/g, '');
    
    const updatedGuests = [...guestDetails];
    updatedGuests[index].phone = phoneValue;
    setGuestDetails(updatedGuests);
    
    // Clear error when user starts typing
    if (errors[`guestPhone_${index}`]) {
      clearErrors(`guestPhone_${index}`);
    }
    
    // Validate phone number length in real-time
    if (phoneValue.length > 0 && phoneValue.length !== 10) {
      setError(`guestPhone_${index}`, {
        type: 'manual',
        message: 'Phone number must be exactly 10 digits'
      });
    }
  };

  //company auto suggestion handle change
  const onHandleAutoSuggestion = (event, value, name) => {
    switch (name) {
      case "companyId":
        return props?.onCompanyAutoSuggestion(event, value);
      case "employeeEmail":
        return props?.onEmployeeAutoSuggestion(event, value);
      default:
        return null;
    }
  };

  const handleDutyTypeDetails = () => {
    if (tempFormData["tripDetails"]?.length > 1) {
      setFormData({
        ...formData,
        tripDetails: tempFormData["tripDetails"] = [bookingFormBorder],
      });
    }
  }

  const handleInput = (e, name, fieldValue) => {
    const fieldName = name || e.target.name;
    clearErrors(fieldName);

    const data = {
      ...formValidationObj,
    };
    if (fieldName === 'employeePhoneNumber') {
      const phoneValue = e.target.value.replace(/\D/g, '');
      // Validate based on country code
      const validation = validatePhoneNumber(phoneValue, country);
      // Always update the state with the current input
      setValue('employeePhoneNumber', phoneValue);
      setPhoneNumber(phoneValue);
      data[fieldName] = phoneValue;
      setFormValidationObj({
        ...formValidationObj,
        [fieldName]: phoneValue,
      });
      // Set or clear error based on validation
      if (!validation.isValid && phoneValue.length > 0) {
        setError('employeePhoneNumber', {
          type: 'manual',
          message: validation.message
        });
      } else {
        clearErrors('employeePhoneNumber');
      }

      // Return early
      return;
      // For non-India codes, continue with normal handling
    }
    if (fieldName === "airportRideType") {
      if (fieldValue === "To-Airport") {
        setFormData({
          ...formData,
          tripDetails: [
            ...toAirportForm(props?.airportTerminalOption, props?.editType),
          ],
        });
      } else if (fieldValue === "From-Airport") {
        setFormData({
          ...formData,
          tripDetails: [
            ...fromAirportForm(props?.airportTerminalOption, props?.editType),
          ],
        });
      }
    } else if (fieldName === "travellerDetails") {
      clearErrors("employeeEmail");
      setValue("employeePhoneNumber", "");
      setValue("employeeName", "");
      setValue("employeeCode", "");
      setValue("departmentCode", "");
      setValue("employeeBranch", "");
      setValue("employeeBranchId", "");

      let tempData = [...formData["travellerDetails"]];
      setCountry({ value: "+91", label: "IN +91" });
      if (fieldValue === "new user") {
        //second index
        tempData[1] = newUser;
        tempData[4] = employeeCode;
        tempData[5].required = true;
        tempData[6] = newBranch(props?.companyBranches, props?.editType);
      } else if (fieldValue === "guestUser") {
        tempData[1] = guestUser;
        tempData[3].required = false;
        tempData[4] = '';
        tempData[5].required = false;
        tempData[6] = newBranch(props?.companyBranches, props?.editType);
      } else {
        tempData[1] = existingUser(props?.companyEmployeeList);
        tempData[4] = employeeCode;
        tempData[5].required = true;
        tempData[6] = existingBranch;
        // Fetch countryCode dynamically from existing user details
        const existingUserDetails = props?.companyEmployeeList?.find(user => user.email === fieldValue?.email);
        setCountry(existingUserDetails?.countryCode || "+91");
      }
      setFormData({ ...formData, travellerDetails: [...tempData] });
    } else if (fieldName === "companyId") {

      handleDutyTypeDetails();
      setAutoCompletFieldValue({
        ...autoCompleteFieldValue,
        companyId: fieldValue,
        employeeEmail: null,
        location: null,
        dutyTypeId: null,
        vehicleCategoryId: null,
      });
      setDomain(fieldValue?.allowedDomains);

      setImage(null);
      const clearFields = ["location", "vehicleCategoryId", "dutyTypeId", "employeeEmail", "employeePhoneNumber", "employeeName", "employeeCode", "departmentCode", "employeeBranch", "employeeBranchId", "travelRequestNumber", "note", "noOfTravelers", "InsuranceFile"];

      for (let fields of clearFields) {
        setValue(fields, "");
      }

      setValue("companyEmail", fieldValue?.companyemail);
      setValue("parentCompany", fieldValue?.parentCompanyName);
      setValue("contractId", fieldValue?.contractId);

      setValue("billingType", Number(fieldValue?.billingType) === 1 ? 'billToIndividual' : Number(fieldValue?.billingType) === 2 ? 'billToCompany' : '');

      setSelectValues((prevState) => ({
        ...prevState,
        billingType: Number(fieldValue?.billingType) === 1 ? 'billToIndividual' : Number(fieldValue?.billingType) === 2 ? 'billToCompany' : '',
      }));

      props?.companyDetails(
        fieldName,
        fieldValue?.value,
        fieldValue?.contractId
      );

      props?.fetchRateCard(fieldName, fieldValue?.value);
      props?.fetchRateCard("contractId", fieldValue?.contractId);

    } else if (fieldName === "dutyTypeId") {

      if (formValues?.dutyTypeId !== e.target.value) {
        setValue('drop', '');
      }

      setAutoCompletFieldValue({
        ...autoCompleteFieldValue,
        vehicleCategoryId: null,
        [fieldName]: fieldValue,
      });

      setValue("vehicleCategoryId", "");
      setValue("package", "");
      setValue("noOfTravelers", "");
      setValue("drop", "");
      setValue('pickup', '');
      setValue('landmark', '');

      props.fetchVehicle(fieldValue);
      props?.fetchRateCard(fieldName, fieldValue?.id);
      dispatch(clearPlaceDetails());

      if (fieldValue?.id === tripDutyTypeEnum.airpotTransfer) {
        setFormData({
          ...formData,
          tripDetails: [
            ...toAirportForm(props?.airportTerminalOption, props?.editType),
          ],
        });
      } else if (fieldValue?.id === tripDutyTypeEnum.rental) {
        setFormData({
          ...formData,
          tripDetails: [
            ...RentalFields(props?.rateCardPackage, props?.editType),
          ],
        });
      } else {
        setFormData({
          ...formData,
          tripDetails: [...outstationFields(props?.editType)],
        });
      }
    } else if (fieldName === "location") {

      handleDutyTypeDetails();
      props?.fetchDutyType(fieldName, fieldValue);
      setAutoCompletFieldValue({
        ...autoCompleteFieldValue,
        dutyTypeId: null,
        vehicleCategoryId: null,
        [fieldName]: fieldValue,
      });

    } else if (fieldName === "employeeEmail") {

      setAutoCompletFieldValue({
        ...autoCompleteFieldValue,
        [fieldName]: fieldValue,
      });

      setValue('employeeEmail', fieldValue?.email);
      setValue('employeePhoneNumber', fieldValue?.phoneNumber);
      setValue('employeeName', fieldValue?.name);
      setValue('employeeCode', fieldValue?.employeeId);
      setValue('departmentCode', fieldValue?.code);
      setValue('employeeBranch', fieldValue?.branchAddress);
      setValue('employeeBranchId', fieldValue?.branchId);
      setCountry(fieldValue?.countryCode || "+91");

    } else if (fieldName === 'vehicleCategoryId') {
      props?.fetchRateCard(fieldName, fieldValue?.value);
      setValue("vehicleSeater", fieldValue?.seater || 0);

      if (!fieldValue?.value) {
        setValue("noOfTravelers", "");
      }

      setAutoCompletFieldValue({
        ...autoCompleteFieldValue,
        [fieldName]: fieldValue,
      });
    } else if (fieldName === 'config') {
      if (e.target.value === 'Point-To-Garage') {
        if (props?.companyEdit) {
          setValue("configRate", selectValues?.configRate || "");
        }
        setdisableGarage({ ...disableGarage, disable: false, required: true })
      } else if(e.target.value === 'Garage-To-Garage') {
        if (props?.companyEdit) {
          setValue("configRate", selectValues?.configRate || "");
        }
        setdisableGarage({ ...disableGarage, disable: true, required: false })
        setGarageRateType('per_km');
        setGarageSlabs([{ minKm: 0, maxKm: 5, rate: '' }]);
      } else {
        setValue("configRate", "");
        setdisableGarage({ ...disableGarage, disable: true, required: false })
      }
    } else if (fieldName === 'newBranch') {
      setValue('employeeBranchId', e.target.value);
    } else if (fieldName === 'tripType') {
      if (Number(e.target.value) === tripDutyTypeEnum.oneWayTrip) {
        setMandatoryField({ ...mandatoryField, field: "oneway", status: true });
      } else if (Number(e.target.value) === tripDutyTypeEnum.roundTrip) {
        setMandatoryField({
          ...mandatoryField,
          field: "roundTrip",
          status: true,
        });
      }
    } else if (
      fieldName === "fromAirportTerminal" ||
      fieldName === "toAirportTerminal"
    ) {
      const destinationAddress = props?.airportTerminalOption?.filter(
        (obj) => obj.value === e.target.value
      );
      props?.onHandleChange(e, destinationAddress?.[0], e.target.name);
    }

    clearErrors(fieldName);
    if (fieldName === "employeeEmail" || fieldName === "dutyTypeId" || fieldName === "location" || fieldName === "vehicleCategoryId") {
      setValue(fieldName, fieldValue);
      data[fieldName] = fieldValue;
    } else if (fieldName === "chooseDate") {
      setValue(name, e);
      data[name] = e;
    } else if (
      fieldName === "billToCreditCard" ||
      fieldName === "billToCompany"
    ) {
      formValues[fieldName] = fieldValue;
      clearErrors("billingDetails");
      if (fieldValue) {
        setValue("billingDetails", fieldValue);
      } else {
        if (!formValues["billToCreditCard"] && !formValues["billToCompany"]) {
          errors["billingDetails"] = true;
          setValue("billingDetails", "");
        }
      }
    } else if (fieldName === "noOfTravelers") {
      const travelerCount = parseInt(fieldValue || e.target.value);
      setValue("noOfTravelers", travelerCount);
      data[fieldName] = travelerCount;
      setFormValidationObj({
        ...formValidationObj,
        [fieldName]: travelerCount,
      });
    } else if (fieldName === 'config') {
      if (e.target.value === 'Point-To-Garage') {
        if (props?.companyEdit) {
          setValue("configRate", selectValues?.configRate || "");
        }
        setdisableGarage({ ...disableGarage, disable: false, required: true })
      } else {
        setValue("configRate", "");
        setdisableGarage({ ...disableGarage, disable: true, required: false })
      }
      
      // Handle Garage-To-Garage selection
      if (e.target.value === 'Garage-To-Garage') {
        // Initialize garage rate configuration
        setGarageRateType('per_km');
        setGarageSlabs([{ minKm: 0, maxKm: 5, rate: '' }]);
      } else {
        setGarageRateType(null)
      }
    } else if (fieldName === "multiDayBooking") {
      const boolVal =
        typeof fieldValue === "boolean"
          ? fieldValue
          : fieldValue?.toString().toLowerCase() === "true";
      setValue("multiDayBooking", boolVal, { shouldValidate: true });
      data[fieldName] = boolVal;
      setFormData({
        ...formData,
        tripDetails: [
          ...RentalFields(props?.rateCardPackage, props?.editType, boolVal),
        ],
      });
    }
    else {
      setValue(
        fieldName,
        textCapitalizeTransform(fieldName, e.target.value, fieldValue)
      );
      data[fieldName] = textCapitalizeTransform(
        fieldName,
        e.target.value,
        fieldValue
      );
      setFormValidationObj({
        ...formValidationObj,
        [fieldName]: textCapitalizeTransform(fieldName, e.target.value, fieldValue),
      });
    }

    if(fieldName === 'endOtpRequired'){
      let val = false;
      if (typeof fieldValue === "boolean"){
        val = fieldValue;
      };
      if (typeof fieldValue === "string") {
        val = fieldValue.toLowerCase() === "true"
      }
      setValue('endOtpRequired', val)
      data[fieldName] = val
    }

    let validationData = handleValidationForm(
      data,
      null,
      domain,
      radioName,
      formValues,
      props?.formType
    );
    setFormError(validationData.errorVal);
  };

  const textCapitalizeTransform = (fieldName, textValue, value) => {
    const textCapitalFieldNames = ["panNumber", "gstNumber"];
    if (textCapitalFieldNames.includes(fieldName)) {
      return textValue?.toUpperCase(fieldName) || value?.toUpperCase(value);
    } else {
      return textValue || value;
    }
  };

  const handleChange = (event, name, value) => {
    setCountry(name === "countryAutocomplete" ? value : event.target.value);
  };

  // ---Form Validation---
  const handelNegativeInput = (event) => {
    if (!event.target.validity.valid) {
      setValue(event?.target.name, "");
    }
  };

  const dummyFunctiom = (e) => {
    return;
  };

  const onSubmit = (data, e) => {

    
    e.preventDefault();
    e.stopPropagation();
    if (fileTypeError || imgError) {
      return;
    }

    // Validate admin/finance member rows before submitting
    if (props?.formName === 'companyAdminFinance') {
      let memberIsValid = true;

      for (const admin of dynamicAdmins) {
        if (!admin.name?.trim() || StringRegex.test(admin.name)) { memberIsValid = false; break; }
        if (!admin.email?.trim() || !emailReg.test(admin.email)) { memberIsValid = false; break; }
        const digits = (admin.phone || '').replace(/\D/g, '');
        if (!digits || digits.length !== 10) { memberIsValid = false; break; }
      }

      if (!memberIsValid) {
        return;
      }

      // Skip handleValidationForm for this form — fields are managed by CustomMemberFields
      props.onSubmittBtn(
        data,
        image,
        country,
        commonSwitch,
        e,
        selectedMultiFiles,
        deleteFileId,
        dynamicDomain,
        commonSwitch,
        dynamicAdmins,
        dynamicFinances
      );
      return;
    }

    // if (guestDetails.length > 0) {
    //   const isGuestDetailsValid = validateGuestDetails();
    //   if (!isGuestDetailsValid && !props.editType) {
    //     return; // Stop submission if guest details are invalid
    //   }
    // }

    // Process guest details

const travelerCount = parseInt(data?.noOfTravelers || 0) - 1;
let finalGuestDetails = [];

if (travelerCount > 0) {
  for (let i = 0; i < travelerCount; i++) {
    const guestName = data[`guestName_${i}`];
    const guestPhone = data[`guestPhone_${i}`];
    const guestCountryCode = data[`guestCountryCode_${i}`] || '+91';

    if (guestName || guestPhone) {
      finalGuestDetails.push({
        name: guestName,
        phone: guestPhone,
        countryCode: guestCountryCode
      });
    }
  }
}

if (finalGuestDetails.length > 0) {
  data.guestDetails = finalGuestDetails;
}

    // Add guest details to form data
    const finalFormData = {
      ...data,
      ...finalGuestDetails && {guestDetails: finalGuestDetails},
      ...(garageRateType && {
        garageRateType: garageRateType,
        garageRateConfig: garageRateType === 'per_km' 
          ? { rate_per_km: parseFloat(selectValues?.garagePerKmRate || 0) }
          : {
              slabs: garageSlabs.map((slab, index) => ({
                minKm: slab.minKm,
                maxKm: index === garageSlabs.length - 1 && slab.maxKm === null ? null : slab.maxKm,
                rate: parseFloat(slab.rate || 0)
              }))
            }
      })
    };


    let validationData = handleValidationForm(
      finalFormData,
      "onSubmit",
      domain,
      radioName,
      formValues,
      props?.formType
    );
    setFormError(validationData.errorVal);

    const handleDynamicFields = (dynamicInputs) => {
      const tempRes = [];
      for (let temp = 0; temp < dynamicInputs?.length; temp++) {
        const gstNumber = dynamicInputs[temp][`gstNumber-${temp}`];
        if (gstNumber?.length === 15 && gstNumberRegex.test(gstNumber)) {
          tempRes.push('validGstNumber');
        } else if (gstNumber?.length === 0) {
          tempRes.push('validGstNumber');
        } else {
          tempRes.push('inValidGstNumber');
          if (validationData.formIsValid) {
            handleWindowScroll(800, "onSubmit");
          }
          setError(`gstNumber-${temp}`);
        }
      }

      if (
        tempRes.includes("inValidGstNumber") &&
        props?.formName !== "dashboardData"
      ) {
        return false;
      } else {
        return true;
      }
    };
    if (validationData.formIsValid && handleDynamicFields(dynamicInputs)) {
      props.onSubmittBtn(
        finalFormData,
        image,
        country,
        props?.formName === 'companyAdminFinance' ? commonSwitch : dynamicInputs,
        e,
        selectedMultiFiles,
        deleteFileId,
        dynamicDomain,
        commonSwitch,
        dynamicAdmins,
        dynamicFinances
      );
      if (props?.payment === "payment") {
        clearErrors();
      }
    }
  };

  const onImageChange = (event) => {
    setFileTypeError("");
    setImgError("");

    if (event.target.files && event.target.files[0]) {
      if (!pdfDocReg.exec(event.target.value)) {
        const typeError = "File type should be in pdf/doc";
        setImage(null);
        setFileTypeError(typeError);
      } else if (pdfDocReg.exec(event.target.value)) {
        if (event.target.files[0].size > imageSize.fiveMb) {
          const errorVal = "File size should not be more than 5 MB";
          setImage(null);
          setImgError(errorVal);
        } else {
          const img = event.target.files[0];
          setImage(img);
        }
      } else {
        setImage(null);
      }
    }
  };

  const handleFileChange = (event) => {
    setMultiFileTypeError("");
    setMultiFileError("");

    if (event.target.files && event.target.files[0]) {
      if (!pdfImgReg.exec(event.target.value)) {
        const typeError = "File type should be in pdf/doc/jpeg/jpg/png";
        setMultiFileTypeError(typeError);
      } else if (pdfImgReg.exec(event.target.value)) {
        if (event.target.files[0].size > imageSize.fiveMb) {
          const errorVal = "File size should not be more than 5 MB";
          setMultiFileError(errorVal);
        } else {
          const img = event.target.files;
          const filesArray = Array.from(img);
          // Update the state with the selected files
          setSelectedMultiFiles([...selectedMultiFiles, ...filesArray]);
        }
      }
    }
  };

  const removeFile = (index) => {
    const removedFile = selectedMultiFiles[index];
    const updatedFiles = selectedMultiFiles.filter((_, i) => i !== index);
    setSelectedMultiFiles(updatedFiles);
    if (typeof removedFile.id !== 'undefined') {
      setDeleteFileId(prevIds => [...prevIds, removedFile.id]);
    }
  };

  // Date Range
  const onSelectDateRange = (newValue, name) => {
    clearErrors(name);
    if (newValue) {
      setValue(name, newValue);
    } else {
      setValue(name, "");
    }
  };

  // ---MinDate and Time---
  let date = new Date()
  const [minDate, setMinDate] = useState(date);
  useEffect(() => {
    setMinDate(date.setMinutes(Math.ceil(date.getMinutes() / 10) * 10 + (props?.bookingBufferTime || 0) / 60))
  }, [props?.bookingBufferTime])

  const handleDisable = (previewDisabled, editDisabled, fieldName) => {

    const isAdminField = fieldName && /^(adminName|adminEmail|adminPhone)_\d+$/.test(fieldName);
    const isFinanceField = fieldName && /^(financeName|financeEmail|financePhone)_\d+$/.test(fieldName);

    if ((fieldName === "noOfTravelers" && !autoCompleteFieldValue?.vehicleCategoryId?.value)
      || (previewDisabled || editDisabled)
      || (isAdminField && commonSwitch?.admin)
      || (isFinanceField && commonSwitch?.finance)) {
      return true;
    }
  };

  //Func for checkboxDefaultValues
  const checkboxDefaultValues = (checkboxType, defaultValues) => {
    
    if (checkboxType === "endOtpRequired"){
        return defaultValues?.endOtpRequired || false
      }
    else if (
      (checkboxType === "billToCreditCard" &&
        (defaultValues?.billingType === billingTypeEnum.billToCreditCard) ||
      defaultValues?.billingType ===
      billingTypeEnum.billToCreditCardAndbillToCompany)
    ) {
      return "billToCreditCard";
    } else if (
      (checkboxType === "billToCompany" &&
        (defaultValues?.billingType === billingTypeEnum.billToCompany) ||
      defaultValues?.billingType ===
      billingTypeEnum.billToCreditCardAndbillToCompany)
    ) {
      return "billToCompany";
    }
  };

  const scrollToUploadFileComponent = () => {
    if (uploadFileRef.current) {
      uploadFileRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleClose = () => {
    props.handleClose();
  };

  const getOptionLabel = (option) => {
    if (option?.description) {
      return option?.description;
    } else if (option?.formatted_address) {
      return option?.formatted_address;
    } else if (option?.vicinity) {
      return option?.name + "," + option?.vicinity;
    } else {
      return "";
    }
  };

  const onGarageLocationInputChange = debounce((value, event) => {
    const data = {
      name: value,
      sessiontoken: "",
      location: `${autoCompleteFieldValue?.location?.coordinates?.[1] || ""},${autoCompleteFieldValue?.location?.coordinates?.[0] || ""}`,
      dutyType: autoCompleteFieldValue?.dutyTypeId?.id,
      locationType: event?.target?.name
    };
  
    if (event?.type === "change" && value) {
      dispatch(getAutoComplete(data));
    }
  }, 1000);
  
  const handleFinanceSwitch = (event) => {
    const name = event?.target?.name;
    setCommonSwitch({ ...commonSwitch, [name]: !commonSwitch[name] })
    if (name === "admin") {
      handleSwitchValue("admin", !commonSwitch[name]);
    }
    else if (name === "finance") {
      handleSwitchValue("finance", !commonSwitch[name]);
    }
  };

  const commonFormSwitch = (name, editStatus, switchDisable) => {

    let disableStatus = false;
    if (!switchDisable || switchDisable === "false") {
      disableStatus = true
    }

    return (
      <FormGroup>
        <FormControlLabel control={<BlueSwitchBtn onChange={handleFinanceSwitch}
          checked={commonSwitch[name]}
          value={commonSwitch[name]}
          name={name}
          color="primary"
          disabled={disableStatus}
        />}
          label="As per in parent company" />
      </FormGroup>
    )
  }

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur()
    // Prevent the page/container scrolling
    e.stopPropagation();
  }

  return (
    <div>
      {formData &&
        Object?.keys(formData)?.map((val, index) => (
          <Box className="multiformComponent  mt30" key={index}>
            <Box className="justifyBetween">
              {val && (
                <Box className={"alignStart pb20"}>
                  {props?.companyTitles?.includes(val) &&
                    <ArrowBackIosRoundedIcon
                      className="font24 colorGrey mr10"
                      role="presentation"
                      onClick={props?.handleNavigate}
                    />
                  }
                  <Typography
                    variant={`${props?.payment === "payment" || props?.formName === 'dashboardData' ? "body1" : "head3"
                      }`}
                    component={"h1"}
                    className={`fw600 ${props.disabled ? "colorGrey" : "colorBlack"
                      }`}
                  >
                    {reservationHeader(val)}
                  </Typography>
                </Box>
              )}
              {(val === "Admin Team Details") &&
                commonFormSwitch("admin", props?.companyEdit, props?.switchDisable)
              }
              {(val === 'Finance Team Details') &&
                commonFormSwitch("finance", props?.companyEdit, props?.switchDisable)
              }
            </Box>
            {val === "Admin Team Details" && props?.formName === 'companyAdminFinance' ? (
              <CustomMemberFields
                members={dynamicAdmins}
                setMembers={setDynamicAdmins}
                fieldPrefix="admin"
                disabled={commonSwitch?.admin}
                sectionLabel="Admin"
                isRequired={true}
              />
            ) : val === "Finance Team Details" && props?.formName === 'companyAdminFinance' ? (
              <CustomMemberFields
                members={dynamicFinances}
                setMembers={setDynamicFinances}
                fieldPrefix="finance"
                disabled={commonSwitch?.finance}
                sectionLabel="Finance"
                isRequired={false}
              />
            ) : (
            <Grid
              container
              spacing={{ md: 2 }}
              columns={{ xs: 1, sm: 3, md: 12 }}
            >
              {formData &&
                formData[val].map((ele, idx) => {
                   // ✅ Placard duty type + dependentField check
                if (!shouldRenderField(ele)) return null;
                return (
                  <Grid item xs={12} sm={ele.gridSize} key={idx}>
                    <Box
                      display={"grid"}
                      gap={3}
                      key={ele?.name}
                      className={
                        (props?.formType !== "reservation" ||
                          val !== "billingType") &&
                        "mb10"
                      }
                    >
                      <FormControl variant="standard">
                        {ele?.label && ele?.label !== 'Guest Details' && (
                          <Typography
                            variant="body2"
                            className="flex fw600 colorBlack mb10"
                          >
                            {ele?.label}
                            {(ele?.required || (ele?.name === 'configRate' && disableGarage?.required) || (ele.name === 'landmark' && pickupLandmarkRequired.landmark)) && (
                              <span className="colorRed">
                                {ele?.star || "*"}
                              </span>
                            )}
                            {ele?.name === "approvalDuration" && (
                              <CommonLabelInfo
                                title={
                                  "The particular duration is given to the user to Approve or raise a Dispute against the Proforma Invoice"
                                }
                              />
                            )}
                            {ele?.name === "DocumentFile" && (
                              <CommonLabelInfo
                                title={
                                  "Upload other documents such as GST, PAN, etc"
                                }
                              />
                            )}
                            {ele.name === 'placardText' && (
                                    <Tooltip title="Preview Placard">
                                      <Button
                                        variant="text"
                                        size="small"
                                        onClick={handlePlacardPreview}
                                        sx={{ 
                                          minWidth: '40px',
                                          '& .MuiButton-startIcon': {
                                          margin: 0
                                        } 
                                        }}
                                      >
                                        <PreviewIcon fontSize="small"/>
                                      </Button>
                                    </Tooltip>
                                  )}
                          </Typography>
                        )}
                        <Box className="flex commonMultiform">
                          {ele?.countrycode && (
                            <Box className="customCountryCode">
                              <FormControl className="br10">
                                {formValues?.travellerDetails !== "existing User" && props?.formType === "reservation" ?
                                  <Box className="customAutocomplete">
                                    <Controller
                                      name="countryCode"
                                      control={control}
                                      render={({ field }) => (
                                        <Autocomplete
                                          {...field}
                                          size="medium"
                                          name="countryCode"
                                          hiddenlabel="true"
                                          disabled={handleDisable(
                                            ele?.fieldDisabled,
                                            props?.disabled
                                          )}
                                          value={country || ""}
                                          popupIcon={<ExpandMoreRoundedIcon />}
                                          options={props?.countryCodeListData || []}
                                          filterSelectedOptions
                                          onChange={(event, value) =>
                                            handleChange(event, "countryAutocomplete", value)
                                          }
                                          clearIcon={null}
                                          renderOption={(props, option) => (
                                            <Box {...props}>
                                              <Typography variant="body2">{option?.label}</Typography>
                                            </Box>
                                          )}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              margin="normal"
                                              inputProps={{
                                                ...params.inputProps,
                                                autoComplete: "disabled",
                                              }}
                                            />
                                          )}
                                        />
                                      )}
                                    />
                                  </Box> :
                                  <Select
                                    disabled={(commonSwitch?.admin || commonSwitch?.finance) || handleDisable(
                                      ele?.fieldDisabled,
                                      props?.disabled
                                    )}
                                    name="countryCode"
                                    value={country}
                                    onChange={handleChange}
                                    inputProps={{
                                      "aria-label": "Without label",
                                    }}
                                    className="br10"
                                  >
                                    <MenuItem
                                      className="colorBlack"
                                      value={country}
                                      Val
                                    >
                                      {country}
                                    </MenuItem>
                                  </Select>}
                              </FormControl>
                            </Box>
                          )}
                          <FormControl
                            fullWidth
                            className="commonFormControl"
                          >
                            {ele?.options ? (
                              <Box className="customSelectOption">
                                <Select
                                  defaultValue={
                                    selectValues[ele?.name] &&
                                    selectValues[ele?.name]
                                  }
                                  IconComponent={(params) => (
                                    <ExpandMoreRoundedIcon
                                      className="mr10"
                                      {...params}
                                    />
                                  )}
                                  disabled={handleDisable(
                                    ele?.fieldDisabled,
                                    props?.disabled
                                  )}
                                  {...register(ele?.name, {
                                    required: ele?.required || false,
                                  })}
                                  onChange={(e) => {
                                    handleInput(e);
                                  }}
                                  displayEmpty
                                >
                                  <InputLabel className="colorGrey ml16">
                                    <Typography
                                      className="colorGrey"
                                      variant="body2"
                                    >
                                      {!selectValues[ele?.name] &&
                                        ele?.placeholder}
                                    </Typography>
                                  </InputLabel>
                                  {ele?.menuOptions &&
                                    ele?.menuOptions.length > 0 &&
                                    ele?.menuOptions?.map(
                                      (option, index) => (
                                        <MenuItem
                                          key={index}
                                          value={
                                            option?.value
                                              ? option.value
                                              : ""
                                          }
                                        >
                                          {ele?.name ===
                                            "fromAirportTerminal" ||
                                            ele?.name ===
                                            "toAirportTerminal" ? (
                                            <Tooltip
                                              title={option?.label}
                                              placement="bottom"
                                            >
                                              {truncateComment(
                                                option?.label,
                                                50
                                              )}
                                            </Tooltip>
                                          ) : ele?.name === "newBranch" ? (
                                            <Tooltip
                                              title={option?.label}
                                              placement="bottom"
                                            >
                                              {truncateComment(
                                                option?.label,
                                                40
                                              )}
                                            </Tooltip>
                                          ) : (
                                            option?.label
                                          )}
                                        </MenuItem>
                                      )
                                    )}
                                </Select>
                                {props?.[`${ele?.name}Loader`]?.fieldType === ele?.name && props?.[`${ele?.name}Loader`]?.loader &&
                                  <Box className="autoCompleteLoader">
                                    <Loader height="66px" loaderSize={"small"} />
                                  </Box>
                                }
                              </Box>
                            ) :
                              ele?.textField ? (
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: '100%' }}>
                                <Box sx={{ flex: 1 }}>
                                <CustomTextfield
                                  ele={ele}
                                  handleInput={handleInput}
                                  props={props}
                                  register={register}
                                  errors={errors}
                                  formError={formError}
                                  handleDisable={handleDisable}
                                  handelNegativeInput={handelNegativeInput}
                                  dummyFunctiom={dummyFunctiom}
                                  disableGarage={disableGarage}
                                  disable={ele?.disable}
                                  numberInputOnWheelPreventChange={numberInputOnWheelPreventChange}
                                />
                                </Box>
                                </Box>
                              ) : ele?.datePicker ? (
                                <Box
                                  className="customDatepicker"
                                  key={datePickerKey}
                                >
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <div className="dateTimePickerContainer">
                                      <DatePicker
                                        open={openDateTimePicker}
                                        onOpen={() => setOpenDateTimePicker(true)}
                                        onClose={() => setOpenDateTimePicker(false)}
                                        {...register(ele?.name, {
                                          required: ele?.required || false,
                                        })}
                                        disabled={props?.disabled}
                                        format="DD/MM/YYYY"
                                        disablePast={ele?.disablePast || false}
                                        minDate={
                                          ele?.disablePast
                                            ? dayjs()
                                            : dayjs(tentureDate).add(1, "day") || ""
                                        }
                                        defaultValue={
                                          (selectValues?.Contracts?.[0]?.date &&
                                            dayjs(
                                              selectValues?.Contracts?.[0]?.date
                                            )) ||
                                          (selectValues?.chooseDate &&
                                            dayjs(selectValues?.chooseDate))
                                        }
                                        onChange={(e) =>
                                          handleInput(e, ele?.name, "")
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            error={
                                              errors[ele?.name] ||
                                              formError[ele?.name]
                                            }
                                            fullWidth
                                            required
                                          />
                                        )}
                                      />
                                      <div
                                        className="clickableOverlay"
                                        onClick={() => setOpenDateTimePicker(true)}
                                      ></div>
                                    </div>
                                  </LocalizationProvider>
                                </Box>
                              ) : ele?.dateRangePicker ? (
                                <Box className="customDateRangePicker">
                                  <DateTab
                                    {...register(ele?.name, {
                                      required: true,
                                    })}
                                    disabled={props?.disabled}
                                    onSelectDateRange={(value) =>
                                      onSelectDateRange(value, ele?.name)
                                    }
                                    dateFrom={selectValues?.tenure?.[0]}
                                    dateTo={selectValues?.tenure?.[1]}
                                    minDate={
                                      props?.type === "dashboardCompany"
                                        ? tentureDate
                                        : ""
                                    }
                                    allowFutureDates={true}
                                    disablePastEndDate={ele?.disablePastEndDate || false}
                                  />
                                </Box>
                              ) : ele?.dateTimePicker ? (
                                <CommonDateTimePicker
                                  ele={ele}
                                  register={register}
                                  selectValues={selectValues}
                                  handleDisable={handleDisable}
                                  errors={errors}
                                  propsData={props}
                                  formError={formError}
                                  clearErrors={clearErrors}
                                  setValue={setValue}
                                  edit={props.editType}
                                  minDate={minDate}
                                />
                              ) : ele?.cityOption ? (
                                <CustomBranchFields
                                  ele={ele}
                                  register={register}
                                  dynamicInputs={dynamicInputs}
                                  setDynamicInputs={setDynamicInputs}
                                  setValue={setValue}
                                  clearErrors={clearErrors}
                                  setError={setError}
                                  errors={errors}
                                  propsData={props}
                                  isDisabled={isDisabled}
                                  companyAddress={props?.defaultValues?.branch}
                                  // Add these props using existing variables
                                  onGarageLocationSearch={onGarageLocationInputChange}
                                  garageLocationOptions={locationData?.predictions || locationData?.results || []}
                                  garageLocationLoader={locationDataLoader?.loading}
                                />

                              ) : ele?.emailDomain ? (
                                <CustomDomainFields
                                  ele={ele}
                                  dynamicDomain={dynamicDomain}
                                  setDynamicDomain={setDynamicDomain}
                                  register={register}
                                  setValue={setValue}
                                  clearErrors={clearErrors}
                                  setError={setError}
                                  errors={errors}
                                  propsData={props}
                                  isDisabled={isDisabled}
                                  companyAddress={
                                    props?.defaultValues?.allowedDomain
                                  }
                                />
                              ) : ele?.checkbox ? (
                                <Controller
                                  name={ele?.name}
                                  control={control}
                                  rules={{ required: ele?.required }}
                                  render={({ field }) => (
                                    <FormGroup>
                                      <Box className="flex">
                                        {ele?.subItems?.map(
                                          (subItem, index) => (
                                            <FormControlLabel
                                              key={index}
                                              name={subItem?.name}
                                              label={
                                                <Typography
                                                  variant={"head5"}
                                                  className="colorBlack fw400"
                                                >
                                                  {subItem?.checkboxLablel}
                                                </Typography>
                                              }
                                              control={
                                                <Checkbox
                                                  {...field}
                                                  id={subItem?.name}
                                                  name={subItem?.name}
                                                  disabled={handleDisable(
                                                    ele?.fieldDisabled,
                                                    props?.disabled
                                                  )}
                                                  value={
                                                    selectValues[
                                                    subItem?.name
                                                    ] || ""
                                                  }
                                                  defaultChecked={
                                                    props?.formType !==
                                                      "reservation"
                                                      ? checkboxDefaultValues(
                                                        subItem?.name,
                                                        props?.defaultValues
                                                      )
                                                      : props?.defaultValues[
                                                      ele?.name
                                                      ]
                                                  }
                                                  onChange={(e, cb) => {
                                                    setValue(
                                                      subItem?.name,
                                                      e.target.checked
                                                    );
                                                    handleInput(
                                                      e,
                                                      subItem?.name,
                                                      e.target.checked
                                                    );
                                                  }}
                                                />
                                              }
                                            />
                                          )
                                        )}
                                      </Box>
                                    </FormGroup>
                                  )}
                                />
                              ) : ele?.switch ? (
                                  <FormGroup>
                                    <Box className="flex">
                                      {ele?.subItems?.map((subItem, index) => (
                                        <Controller
                                          key={index}
                                          name={subItem?.name} // 👈 each switch has its own field
                                          control={control}
                                          rules={{ required: subItem?.required }}
                                          defaultValue={props?.defaultValues?.[subItem?.name] || false}
                                          render={({ field }) => (
                                            <FormControlLabel
                                              label={
                                                <Typography variant="head5" className="colorBlack fw400">
                                                  {subItem?.checkboxLablel}
                                                </Typography>
                                              }
                                              control={
                                                <Switch
                                                  {...field}
                                                  id={subItem?.name}
                                                  name={subItem?.name}
                                                  disabled={handleDisable(
                                                    ele?.fieldDisabled,
                                                    props?.disabled
                                                  )}
                                                  checked={field.value || false}
                                                  onChange={(e) => {
                                                    const newValue = !!e.target.checked;
                                                    field.onChange(newValue);
                                                    handleInput(e, subItem?.name, newValue);
                                                  }}
                                                />
                                              }
                                            />
                                          )}
                                        />
                                      ))}
                                    </Box>
                                  </FormGroup>
                                )
                               : ele?.fileUpload ? (
                                <Box
                                  className={`customFileUploader ${(ele?.fieldDisabled || props?.disabled) &&
                                    "disabled"
                                    }`}
                                >
                                  <Button
                                    ref={uploadFileRef}
                                    variant="contained"
                                    component="label"
                                    className="fileUploader commonBorder"
                                    disabled={handleDisable(
                                      ele?.fieldDisabled,
                                      props?.disabled
                                    )}
                                  >
                                    <Box className="fileUploadContainer justifyCenter">
                                      <Box>
                                        <Typography
                                          variant="body2"
                                          component={"h5"}
                                          className="colorGrey fw400 justifyCenter textCapitalize"
                                        >
                                          {ele?.placeholder
                                            ? ele?.placeholder
                                            : "Upload Contract"}
                                          <Typography
                                            component={"span"}
                                            variant="head4"
                                            className=" fw400 "
                                          >
                                            <img
                                              src={UploadIcon}
                                              className="marginInline10"
                                              alt="image"
                                            />
                                          </Typography>
                                        </Typography>
                                      </Box>

                                      <input
                                        type="file"
                                        {...register(ele?.name, {
                                          required: image?.name
                                            ? false
                                            : ele?.required,
                                          onChange: (e) => onImageChange(e),
                                        })}
                                        hidden
                                        accept=".pdf,.doc"
                                      />
                                    </Box>
                                  </Button>
                                  {image?.name && (
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                      <Typography className="font14">
                                        <Tooltip
                                          title={image?.name}
                                          placement="bottom"
                                        >
                                          {truncateComment(image?.name, 20)}
                                        </Tooltip>
                                      </Typography>
                                      <IconButton
                                        size="small"
                                        aria-label="preview document"
                                        onClick={openFilePreview}
                                        sx={{ p: 0.5, minHeight: "0 !important", width: 32, height: 32, borderRadius: "50%" }}
                                      >
                                        <PreviewIcon fontSize="small" />
                                      </IconButton>
                                    </Box>
                                  )}
                                  {imgError && imgError !== null && (
                                    <Typography
                                      variant={"body2"}
                                      className="errorMessage"
                                    >
                                      {imgError}
                                    </Typography>
                                  )}
                                  {fileTypeError &&
                                    fileTypeError !== null && (
                                      <Typography
                                        variant={"body2"}
                                        className="errorMessage"
                                      >
                                        {imgError}
                                      </Typography>
                                    )}
                                </Box>
                              ) : ele?.multifileUpload ? (
                                <Box>
                                  <CommonMultiFile
                                    handleFileChange={handleFileChange}
                                    selectedMultiFiles={selectedMultiFiles}
                                    removeFile={removeFile}
                                  />
                                  {multiFileError &&
                                    multiFileError !== null && (
                                      <Typography
                                        variant={"body2"}
                                        className="errorMessage"
                                      >
                                        {multiFileError}
                                      </Typography>
                                    )}
                                  {multiFileTypeError &&
                                    multiFileTypeError !== null && (
                                      <Typography
                                        variant={"body2"}
                                        className="errorMessage"
                                      >
                                        {multiFileTypeError}
                                      </Typography>
                                    )}
                                </Box>
                              ) : ele?.singleAutoComplete || ele?.reservationAutoComplete ? (
                                <Box className="customAutocomplete">
                                  <Controller
                                    name={ele?.name}
                                    control={control}
                                    rules={{
                                      required: ele?.required || false,
                                    }}
                                    render={({ field }) => (
                                      <Autocomplete
                                        {...field}
                                        size="medium"
                                        name={ele?.name}
                                        hiddenlabel="true"
                                        disabled={handleDisable(
                                          ele?.fieldDisabled,
                                          props?.disabled
                                        )}
                                        value={ele?.reservationAutoComplete && (autoCompleteFieldValue[ele?.name] || "")}
                                        popupIcon={<ExpandMoreRoundedIcon />}
                                        options={
                                          ele?.optionData?.length > 0
                                            ? ele?.optionData
                                            : []
                                        }
                                        defaultValue={
                                          selectValues?.[ele?.name]?.value
                                            ? selectValues?.[ele?.name]
                                            : selectValues?.[ele?.name]
                                              ? selectValues?.[ele?.name]
                                              : ""
                                        }
                                        filterSelectedOptions
                                        onChange={(event, value) =>
                                          handleInput(event, ele.name, value)
                                        }
                                        onInputChange={(event, value) =>
                                          onHandleAutoSuggestion(
                                            event,
                                            value,
                                            ele?.name
                                          )
                                        }
                                        clearIcon={null}
                                        renderOption={(props, option) => (
                                          <Box {...props}>
                                            {option?.label}
                                          </Box>
                                        )}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            margin="normal"
                                            placeholder={ele?.placeholder}
                                            inputProps={{
                                              ...params.inputProps,
                                              autoComplete: "disabled",
                                            }}
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                  {props?.[`${ele?.name}Loader`]?.fieldType === ele?.name && props?.[`${ele?.name}Loader`]?.loader &&
                                    <Box className="autoCompleteLoader">
                                      <Loader height="66px" loaderSize={"small"} />
                                    </Box>
                                  }
                                </Box>
                              ) : ele?.google ? (
                                <CommonGoogleAutoComplete
                                  defaultValue={selectValues[ele?.name]}
                                  getOptionLabel={(option) =>
                                    getOptionLabel(option)
                                  }
                                  disabled={handleDisable(
                                    ele?.fieldDisabled,
                                    props?.disabled
                                  )}
                                  options={
                                    props?.locationData?.length > 0
                                      ? props?.locationData
                                      : []
                                  }
                                  onHandleChange={(event, value) => {
                                    onHandleChange(event, value, ele?.name);
                                  }}
                                  onInputChange={onInputChangeVal}
                                  ele={ele}
                                  register={register}
                                  pickupLandmarkRequired={pickupLandmarkRequired}
                                  fieldType={props?.[`${ele?.name}Loader`]?.fieldType}
                                  fieldLoader={props?.[`${ele?.name}Loader`]?.loader}
                                />
                              ) : ele?.radio ? (
                                <FormControl>
                                  <Controller
                                    name={ele?.name}
                                    control={control}
                                    rules={{ required: ele?.required }}
                                    render={({ field }) => {
                                      return (
                                        <RadioGroup
                                          row
                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                          defaultValue={
                                            selectValues[ele?.name]
                                          }
                                          onChange={(e) => {
                                            handleInput(
                                              e,
                                              ele?.name,
                                              e.target.value
                                            );
                                          }}
                                        >
                                          {ele?.values.map((value) => (
                                            <FormControlLabel
                                              key={value.label}
                                              value={value.value || ""}
                                              control={
                                                <Radio
                                                  disabled={handleDisable(
                                                    ele?.fieldDisabled,
                                                    props?.disabled
                                                  )}
                                                />
                                              }
                                              label={value.label}
                                            />
                                          ))}
                                        </RadioGroup>
                                      );
                                    }}
                                  />
                                </FormControl>
                              ) : ele?.dashedBorder ? (
                                <Box className="dashedBorder mt30"></Box>
                              ) : ele?.guestDetails && !ele?.fieldDisabled ? (
                                <Box className="guestDetailsContainer" key={`${ele.name}container`}>
                                  {parseInt(formValues?.noOfTravelers || 0) - 1 > 0 && (
                                    <>
                                      <Typography variant="body2" className="flex fw600 colorBlack mb10">
                                        {ele.label}
                                        {/* <span className="colorRed">*</span> */}
                                      </Typography>
                                      <Grid container spacing={2}>
                                        {guestDetails.map((guest, index) => (
                                          <React.Fragment key={`guest${index}`}>
                                            <Grid item xs={12} sm={6}>
                                              <Box className="guestInputContainer">
                                                <p className="text-sm font-semibold mb-2">{`Guest ${index + 1} Name`}</p>
                                                <CustomTextfield
                                                  ele={{
                                                    textField: true,
                                                    gridSize: 12,
                                                    // required: true,
                                                    placeholder: `Enter Guest ${index + 1} Name`,
                                                    type: "text",
                                                    name: `guestName_${index}`,
                                                    label: `Guest ${index + 1} Name`,
                                                  }}
                                                  handleInput={(e) => {
                                                    handleGuestNameChange(e, index);
                                                    setValue(`guestName_${index}`, e.target.value);
                                                  }}
                                                  props={props}
                                                  register={register}
                                                  errors={errors}
                                                  formError={formError}
                                                  handleDisable={handleDisable}
                                                  handelNegativeInput={handelNegativeInput}
                                                  dummyFunctiom={dummyFunctiom}
                                                  disableGarage={disableGarage}
                                                  numberInputOnWheelPreventChange={numberInputOnWheelPreventChange}
                                                />
                                                
                                                {/* {errors[`guestName_${index}`] && (
                                                  <Typography variant="body2" className="errorMessage">
                                                    {errors[`guestName_${index}`].message}
                                                  </Typography>
                                                )} */}
                                              </Box>
                                            </Grid>
                                            
                                            <Grid item xs={12} sm={6}>
                                              <Box className="guestInputContainer">
                                                <p className="text-sm font-semibold mb-2">{`Guest ${index + 1} Phone Number`}</p>
                                                <div className="flex flex-row gap-3 w-full">
                                                  <Controller
                                                    name={`guestCountryCode_${index}`}
                                                    control={control}
                                                    render={({ field }) => (
                                                      <Autocomplete
                                                        {...field}
                                                        size="medium"
                                                        name={`guestCountryCode_${index}`}
                                                        hiddenLabel={true}
                                                        disabled={handleDisable(ele?.fieldDisabled, props?.disabled)}
                                                        value={guestDetails[index]?.countryCode}
                                                        popupIcon={<ExpandMoreRoundedIcon />}
                                                        options={props?.countryCodeListData}
                                                        filterSelectedOptions
                                                        onChange={(e, value) => {
                                                          const updatedGuests = [...guestDetails];
                                                          updatedGuests[index].countryCode = value;
                                                          setGuestDetails(updatedGuests);
                                                          setValue(`guestCountryCode_${index}`, value);
                                                        }}
                                                        clearIcon={null}
                                                        sx={{
                                                          minWidth: "120px",
                                                          "& .MuiAutocomplete-input": {
                                                            minWidth: "60px !important",
                                                            paddingRight: "40px !important",
                                                          },
                                                          "& .MuiAutocomplete-endAdornment": {
                                                            right: "8px",
                                                          },
                                                        }}
                                                        renderOption={(props, option) => (
                                                          <Box
                                                            {...props}
                                                            sx={{
                                                              display: "flex",
                                                              alignItems: "center",
                                                              padding: "8px 12px",
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            <Typography
                                                              variant="body2"
                                                              sx={{ whiteSpace: "nowrap" }}
                                                            >
                                                              {option?.label}
                                                            </Typography>
                                                          </Box>
                                                        )}
                                                        renderInput={(params) => (
                                                          <TextField
                                                            {...params}
                                                            margin="normal"
                                                            sx={{
                                                              "& .MuiOutlinedInput-root": {
                                                                minWidth: "120px",
                                                              },
                                                            }}
                                                            inputProps={{
                                                              ...params.inputProps,
                                                              autoComplete: "disabled",
                                                              style: { minWidth: "60px", paddingRight: "8px" },
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                    )}
                                                  />
                                                  
                                                  <CustomTextfield
                                                    ele={{
                                                      textField: true,
                                                      gridSize: 12,
                                                      // required: true,
                                                      placeholder: `Enter Guest ${index + 1} Phone Number`,
                                                      type: "tel",
                                                      name: `guestPhone_${index}`,
                                                      label: `Guest ${index + 1} Phone`,
                                                    }}
                                                    handleInput={(e) => {
                                                      handleGuestPhoneChange(e, index);
                                                      setValue(`guestPhone_${index}`, e.target.value.replace(/\D/g, ''));
                                                    }}
                                                    props={props}
                                                    register={register}
                                                    errors={errors}
                                                    formError={formError}
                                                    handleDisable={handleDisable}
                                                    handelNegativeInput={handelNegativeInput}
                                                    dummyFunctiom={dummyFunctiom}
                                                    disableGarage={disableGarage}
                                                    numberInputOnWheelPreventChange={numberInputOnWheelPreventChange}
                                                  />
                                                </div>
                                                {/* Show error message for guest phone */}
                                                {/* {errors[`guestPhone_${index}`] && (
                                                  <Typography variant="body2" className="errorMessage">
                                                    {errors[`guestPhone_${index}`].message}
                                                  </Typography>
                                                )} */}
                                              </Box>
                                            </Grid>
                                          </React.Fragment>
                                        ))}
                                      </Grid>
                                    </>
                                  )}
                                </Box>
                              ) : ele?.garageRateConfig ? (
                                  <GarageRateConfiguration
                                    setGarageRateType={setGarageRateType}
                                    setGarageSlabs={setGarageSlabs}
                                    garageSlabs={garageSlabs}
                                    garageRateType={garageRateType}
                                    selectValues={selectValues}
                                    setSelectValues={setSelectValues}
                                    setValue={setValue}
                                  />
                              ) : (
                                  ""
                                )}
                          </FormControl>
                        </Box>
                        {errors[ele?.name] && (
                          <Typography
                            variant={"body2"}
                            className="errorMessage"
                          >
                            {errors[ele?.name]?.message || "This field is required"}
                          </Typography>
                        )}
                        {formError[ele?.name] && (
                          <div className="errorMessage">
                            {formError[ele?.name]}
                          </div>
                        )}
                      </FormControl>
                    </Box>
                  </Grid>
                )
})}
            </Grid>
            )}
          </Box>
        ))}

      {/* {props.rateCard && <RateCard companyContractId={props?.contractId} />} */}

      {props.rateCard && <RateCardV1 companyContractId={props?.contractId} isConfigureMode={true}></RateCardV1>}

      {props?.FareBreakUp && (
        <>
          <FareBreakUp dutyTypeLabel={props?.dutyTypeLabel} type={props.type}/>
          < CabFacilities />
        </>
      )}

      {props?.button && (
        <Box
          className={`${props?.formName === "dashboardData"
            ? "justifyCenter marginBlock50"
            : "flex"
            } mt30`}
        >
          <CommonButton
            name={props?.button}
            type="button"
            btnClass={props?.btnClass}
            onClick={handleSubmit(onSubmit)}
          />
          {props?.companyEdit && props?.formType === 'companyOnbaording' &&
            <CommonButton
              name={'Skip'}
              btnClass={'btnSkip btnTransparent ml40 btnBorder1px'}
              onClick={props?.btnAction} />
          }
        </Box>
      )}

      {props?.payment &&
        props?.payment === "payment" &&
        !props?.disabled && (
          <Box>
            <Grid container className="btnDialogContainer ">
              <Grid item xs={3}>
                <Button
                  variant="contained"
                  size="medium"
                  className={`buttonSubmit ${isDisabled ? "buttonSubmitDisabled" : ""
                    }`}
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                  fullWidth
                  disabled={isDisabled || props?.disabled}
                >
                  Submit
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  variant="contained"
                  size="medium"
                  className="cancelAddBtn ml40"
                  fullWidth
                  onClick={() => {
                    handleClose();
                  }}
                  disabled={isDisabled || props?.disabled}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Box>
        )}
        {previewModal && (
  <PlacardModal
    open={previewModal}
    handleClose={handlePreviewClose}
    text={selectedTripId}
  />
)}
    </div>
  );
}